module.exports = __webpack_public_path__ + "img/profile.a1302c76.svg";